/*
Into this file, we will basically put all the variables that should be constants and should be reused across the project.

The goal of having this file with all these variables is that it will allow us to easily configure our project by simply changing some of the data that is in this configuration file.

We will not want to put all the variables here in this file. The only variables that we do want here are the ones that are responsible for kind of defining some important data about the application itself.

*/

// export const API_URL = 'http://127.0.0.1:5000/api/v1/';
export const API_URL = 'https://pragya-enterprises-fn.vercel.app/api/v1/';
// export const ASSETS = 'http://127.0.0.1:5000/';
export const ASSETS = 'https://pragya-enterprises-fn.vercel.app/';
export const TIMEOUT_SEC = 10;
// export const RES_PER_PAGE = 10;
// export const KEY = '7e697dde-b785-48d6-a2ba-1151d33cb19e';
export const MODAL_CLOSE_SEC = 2.5;
// export const URL = 'http://127.0.0.1:1234/';
export const URL = 'https://www.pragya.enterprises/';
export const PLATFORM_FEE = 2;
export const TAX = 0;
